<script setup lang="ts">
interface Props {
  message: string;
}

interface Emits {
  (e: 'dismiss'): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();
</script>

<template>
  <div
    class="flex items-start gap-3 rounded-md bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-800"
    role="alert"
    aria-live="assertive"
    data-testid="report-error-banner"
  >
    <svg
      class="shrink-0 h-4 w-4 mt-0.5 text-red-600"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fill-rule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-11.25a.75.75 0 00-1.5 0v4.5a.75.75 0 001.5 0v-4.5zm-.75 7a.75.75 0 100-1.5.75.75 0 000 1.5z"
        clip-rule="evenodd"
      />
    </svg>
    <span class="flex-1">{{ message }}</span>
    <button
      class="shrink-0 text-red-600 hover:text-red-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 rounded"
      aria-label="Dismiss error"
      @click="emit('dismiss')"
    >
      ×
    </button>
  </div>
</template>
